import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Card from "components/atoms/Card";

import {
  useStartGuestInterestInventoryTestMutation,
  useStartGuestSessionMutation,
} from "generated/graphql";
import {
  Label,
  CompletedBar,
  InProgressBar,
  ChartInfo,
  ChartInfoText,
  ProgressBarWrapper,
  CompletedInfoText,
  Container,
  StartAgainButton,
} from "./styles";
import { Props } from "./types";

const TestProgressBar: FC<Props> = ({
  completed,
  allQuestions,
  isFreeTest,
}) => {
  const { t } = useTranslation();
  const completedValue = Math.round((completed * 100) / allQuestions);
  const [animatedCompletedValue, setAnimatedCompletedValue] = useState(
    completedValue
  );
  const inProgressValue = 100 - completedValue;
  const [startGuestSession] = useStartGuestSessionMutation();
  const [
    startGuestInterestInventoryTest,
  ] = useStartGuestInterestInventoryTestMutation();

  useEffect(() => {
    let animation: number;
    if (animatedCompletedValue < completedValue)
      animation = setTimeout(
        () => setAnimatedCompletedValue((oldValue) => oldValue + 1),
        20
      );
    return () => clearTimeout(animation);
  }, [animatedCompletedValue, completedValue]);

  const startAgain = () => {
    startGuestSession()
      .then(() => startGuestInterestInventoryTest())
      .then(() => window.location.reload());
  };

  return (
    <Container>
      <Card styles={{ padding: "2.4rem 2.4rem 1.6rem 2.4rem" }}>
        <Label>{t("student.progress")}</Label>
        <div>
          <ChartInfo>
            <div>{animatedCompletedValue}%</div>
            {completed < 100 && (
              <ChartInfoText>{t("student.keepGoing")}</ChartInfoText>
            )}
          </ChartInfo>
          <ProgressBarWrapper>
            <CompletedBar width={completedValue} />
            <InProgressBar width={inProgressValue} />
          </ProgressBarWrapper>
          <CompletedInfoText>
            {completed} / {allQuestions} {t("student.completed").toLowerCase()}
          </CompletedInfoText>
        </div>
      </Card>
      <div>
        {isFreeTest && (
          <StartAgainButton onClick={startAgain}>Start again</StartAgainButton>
        )}
      </div>
    </Container>
  );
};

export default TestProgressBar;
